import { logUsage } from 'owa-analytics';
import { isMorningBriefing } from './currentTimeCheckUtils';
import type { MailboxInfo } from 'owa-client-types';

/**
 * Helper function to log when inbox briefing prompt is triggered, either from the SUA suggestion or the nudge.
 */
export function logInboxBriefingsTriggered(
    mailboxInfo: MailboxInfo,
    source: 'InboxBriefingsSUA' | 'InboxBriefingsNudge'
): void {
    logUsage('CopilotInboxBriefingsTriggered', mailboxInfo, {
        source,
        briefing: isMorningBriefing() ? 'morning' : 'evening',
    });
}
